import { useNavigate } from '@tanstack/react-router';
import { TrackingListScreen } from '@mrrmlab/feature-tracking';

export function PaketeRoute() {
  const navigate = useNavigate();
  return (
    <TrackingListScreen
      onOpenTracking={(t) => navigate({ to: '/pakete/$trackingId', params: { trackingId: t.id } })}
    />
  );
}
